export default "__VITE_PUBLIC_ASSET__14507b0d__"